import { DocumentTypeEnum } from "../../../../../generated/types";

/**
 * Normalize API string to DocumentTypeEnum for comparison.
 * Backend returns DOCUMENT | IMAGE | PROJECT.
 */
export function parseDocumentType(
  value: string | null | undefined
): DocumentTypeEnum {
  const u = value?.toUpperCase();
  if (u === "IMAGE") return DocumentTypeEnum.Image;
  if (u === "PROJECT") return DocumentTypeEnum.Project;
  return DocumentTypeEnum.Document;
}

export { DocumentTypeEnum };

/**
 * Infer document type from file extension for the uploads page.
 * Backend enum: image | document | project.
 */
const IMAGE_EXTENSIONS = new Set(
  [
    "jpg",
    "jpeg",
    "png",
    "gif",
    "webp",
    "bmp",
    "svg",
    "heic",
  ].map((e) => e.toLowerCase())
);

const DOCUMENT_EXTENSIONS = new Set(
  [
    "pdf",
    "xlsx",
    "xls",
    "docx",
    "doc",
    "pptx",
    "ppt",
    "txt",
    "csv",
  ].map((e) => e.toLowerCase())
);

const PROJECT_EXTENSIONS = new Set(["skt"].map((e) => e.toLowerCase()));

export type DocumentTypeValue = "image" | "document" | "project";

export function documentTypeFromExtension(filename: string): DocumentTypeValue {
  const ext = filename.split(".").pop()?.toLowerCase() ?? "";
  if (IMAGE_EXTENSIONS.has(ext)) return "image";
  if (PROJECT_EXTENSIONS.has(ext)) return "project";
  if (DOCUMENT_EXTENSIONS.has(ext)) return "document";
  return "document";
}

export const DOCUMENT_TYPE_LABELS: Record<DocumentTypeValue, string> = {
  image: "Image",
  document: "Document",
  project: "Project",
};

/** Labels keyed by DocumentTypeEnum (backend value). */
export const DOCUMENT_TYPE_ENUM_LABELS: Record<DocumentTypeEnum, string> = {
  [DocumentTypeEnum.Image]: "Imagem",
  [DocumentTypeEnum.Document]: "Document",
  [DocumentTypeEnum.Project]: "Project",
};
